var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-scr"},[_c('vue-element-loading',{attrs:{"active":_vm.isLoading,"is-full-screen":_vm.showFull,"text":_vm.loadingText,"color":"#353cd6"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }